import { SVGProps, Ref, forwardRef } from 'react';

export const CameraFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6.732 8.734c0-.459.117-.767.259-.937.104-.124.344-.33 1.007-.33s.903.206 1.007.33c.142.17.26.478.26.937 0 .458-.118.767-.26.937-.104.124-.344.329-1.007.329s-.903-.205-1.007-.33c-.142-.17-.259-.478-.259-.936"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m10.664 1 1.331 1.927c3.466.168 4.001 1.204 4.001 5.667v.712c0 4.982-.667 5.694-5.332 5.694H5.332C.667 15 0 14.288 0 9.306v-.712c0-4.463.535-5.5 4-5.667L5.333 1zM5.332 8.734c0-1.333.667-2.666 2.666-2.666 2 0 2.666 1.333 2.666 2.666S9.998 11.4 7.998 11.4s-2.666-1.333-2.666-2.666"
                fill="currentColor"
            />
        </g>
    </svg>
));
CameraFilledSize16Glyph.displayName = 'CameraFilledSize16Glyph';
